exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gallery-container{margin:0 auto;max-width:1200px;padding:0 1rem}div.gallery{margin:1rem;cursor:pointer;display:flex;flex-direction:column}div.gallery img{width:100%;height:auto;display:block}div.gallery:hover{border:1px solid #777}@media screen and (min-width:320px){.grid{display:flex;flex-wrap:wrap;flex-direction:row;justify-content:center}.gallery{width:calc(50% - 2rem)}.gallery:nth-child(5),.gallery:nth-child(6){display:none}}@media screen and (min-width:767px){.gallery{width:calc(24% - 2rem)}}@media screen and (min-width:991px){.gallery{display:inline-block;width:calc(15% - 2rem)}.gallery:nth-child(5),.gallery:nth-child(6){display:flex}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b490898","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Gallery.vue
// module id = 159
// module chunks = 0